import React from "react";
import { Typography, Paper } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { COLORS } from "../styles/theme";

interface StyledHeaderBoxProps {
  title: string;
  subtitle?: string;
  awsAccount?: string;
  color?: string;
  icon?: string | React.ReactNode;
  infoTitle?: string;
  infoMessage: string | React.ReactNode;
}

const StyledHeaderBox: React.FC<StyledHeaderBoxProps> = ({
  title,
  subtitle,
  awsAccount,
  color = COLORS.orange,
  icon,
  infoTitle = "About This Workflow",
  infoMessage,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <Paper
        elevation={2}
        style={{
          width: "100%",
          padding: 24,
          borderRadius: 8,
          borderLeft: `6px solid ${color}`,
          backgroundColor: COLORS.white,
          marginBottom: 24,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          {icon && (
            <div
              style={{
                backgroundColor: color,
                borderRadius: "50%",
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 16,
              }}
            >
              {typeof icon === "string" ? (
                <Typography
                  style={{
                    color: COLORS.white,
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                >
                  {icon}
                </Typography>
              ) : (
                icon
              )}
            </div>
          )}
          <div>
            <Typography
              variant="h6"
              style={{
                color: COLORS.textPrimary,
                fontWeight: 600,
                marginBottom: 4,
              }}
            >
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="textSecondary">
                {subtitle}
              </Typography>
            )}
            {awsAccount && (
              <Typography
                variant="caption"
                color="textSecondary"
                style={{ display: "block", fontStyle: "italic" }}
              >
                AWS Account: {awsAccount}
              </Typography>
            )}
          </div>
        </div>

        <Alert severity="info">
          <Typography
            variant="body2"
            style={{ fontWeight: "bold", marginBottom: 4 }}
          >
            {infoTitle}
          </Typography>
          <Typography variant="body2">{infoMessage}</Typography>
        </Alert>
      </Paper>
    </div>
  );
};

export default StyledHeaderBox;
